import {
  dateFormatter,
  detailDateFormatter,
  dateFormatter2,
  chartDateFormatter4,
  chartDateFormatter5,
  chartDateFormatter6,
  chartDateFormatter7,
  chartDateFormatter8,
  chartDateFormatter9,
  chartDateFormatter10,
  chartDateFormatter11,
  chartDateFormatter12,
  chartDateFormatter13,
  chartDateFormatter14,
} from 'utils/common'
import { isEmpty } from 'lodash';

// CHART TYPE
export const CHART_TYPE_LINE = 'line'
export const CHART_TYPE_AREA = 'area'
export const CHART_TYPE_BAR = 'bar'
export const CHART_TYPE_PIE = 'pie'
export const CHART_TYPE_DOUGHNUT = 'doughnut'
export const CHART_TYPE_GAUGE = 'gauge'
export const CHART_TYPE_TABLE = 'table'
export const CHART_TYPE_CARD = 'card'
export const CHART_TYPE_HEATMAP = 'heatmap'
export const CHART_TYPE_MAP = 'map'
export const CHART_TYPE_INSIGHTS = 'insights'

// CHART INTERVAL
export const INTERVAL_DAY = 'Days'
export const INTERVAL_MINUTE = 'Minutes'
export const INTERVAL_HOUR = 'Hours'
export const INTERVAL_WEEK = 'Weeks'
export const INTERVAL_MONTH = 'Months'
export const INTERVAL_YEAR = 'Years'

export const CHART_TYPE_OPTIONS = [
  { value: CHART_TYPE_LINE, label: 'Line', isDefault: true },
  { value: CHART_TYPE_AREA, label: 'Area' },
  { value: CHART_TYPE_BAR, label: 'Bar' },
  { value: CHART_TYPE_PIE, label: 'Pie' },
  { value: CHART_TYPE_DOUGHNUT, label: 'Donut' },
  { value: CHART_TYPE_GAUGE, label: 'Gauge' },
  { value: CHART_TYPE_CARD, label: 'Card' },
  { value: CHART_TYPE_TABLE, label: 'Table' },
  { value: CHART_TYPE_HEATMAP, label: 'Heatmap' },
  { value: CHART_TYPE_MAP, label: 'Map' },
]

const LEGEND_OPTIONS = [
  { value: 'below', label: 'Below', isDefault: true },
  { value: 'right', label: 'Right Side' },
]

const CHART_LAYOUT_OPTIONS = [
  { value: 'stacked', label: 'Stacked', isDefault: true },
  { value: 'sideBySide', label: 'Side-by-Side' },
]

const COLUMN_METRIC_DATA_OPTIONS = [
  { value: 'raw', label: 'Raw data', isDefault: true },
  { value: 'aggregated', label: 'Aggregated data' },
]

const FORMAT_OPTIONS = [
  { value: 'Default', label: 'Default', isDefault: true },
  { value: '10', label: '10', isDefault: false },
  { value: '100', label: '100', isDefault: false },
  { value: '1000', label: 'k(thousands)', isDefault: false },
  { value: '1000000', label: 'm(millions)', isDefault: false },
  { value: '1000000000', label: 'b(billions)', isDefault: false },
]

const DECIMAL_OPTIONS = [
  { value: 'fromData', label: 'Text / From Data', isDefault: true },
  { value: 0, label: '0' },
  { value: 1, label: '1' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
  { value: 4, label: '4' },
  { value: 5, label: '5' },
  { value: 6, label: '6' },
  { value: 7, label: '7' },
  { value: 8, label: '8' },
]

const THRESHOLD_TYPE_OPTIONS = [
  { value: 'percent', label: 'Percent', isDefault: true },
  { value: 'absolute', label: 'Absolute' }
]

const THRESHOLD_TYPE_LABEL_OPTIONS = [
  { value: 'percent', label: 'Percent', isDefault: true },
  { value: 'absolute', label: 'Absolute' },
  { value: 'label', label: 'Label' }
]

const DATE_FORMAT_OPTIONS = [
  { value: 'dateFormatter2', label: dateFormatter2(new Date(), true), isDefault: true },
  { value: 'dateFormatter', label: dateFormatter(new Date(), true) },
  { value: 'dateFormatter3', label: detailDateFormatter(new Date(), true) },

  { value: 'chartDateFormatter4', label: chartDateFormatter4(new Date()) },
  { value: 'chartDateFormatter5', label: chartDateFormatter5(new Date()) },
  { value: 'chartDateFormatter6', label: chartDateFormatter6(new Date()) },
  { value: 'chartDateFormatter7', label: chartDateFormatter7(new Date()) },
  { value: 'chartDateFormatter8', label: chartDateFormatter8(new Date()) },
  { value: 'chartDateFormatter9', label: chartDateFormatter9(new Date()) },
  { value: 'chartDateFormatter10', label: chartDateFormatter10(new Date()) },
  { value: 'chartDateFormatter11', label: chartDateFormatter11(new Date()) },
  { value: 'chartDateFormatter12', label: chartDateFormatter12(new Date()) },
  { value: 'chartDateFormatter13', label: chartDateFormatter13(new Date()) },
  { value: 'chartDateFormatter14', label: chartDateFormatter14(new Date()) },
]

const DATE_RANGE_OPTIONS = [
  { value: 'Day', label: '1 Day' },
  { value: 'Week', label: 'Last 1 week' },
  { value: '15day', label: 'Last 15 days' },
  { value: 'Month', label: 'Last 1 month' },
]

const CHART_INTERVAL_OPTIONS = [
  { value: INTERVAL_MINUTE, label: INTERVAL_MINUTE },
  { value: INTERVAL_HOUR, label: INTERVAL_HOUR, isDefault: true },
  { value: INTERVAL_DAY, label: INTERVAL_DAY },
  { value: INTERVAL_WEEK, label: INTERVAL_WEEK },
  { value: INTERVAL_MONTH, label: INTERVAL_MONTH },
  { value: INTERVAL_YEAR, label: INTERVAL_YEAR },
]

export const DATA_POINT_OPTIONS = [
  { value: 'min', label: 'Minimun Value' },
  { value: 'max', label: 'Maximum Value' },
  { value: 'avg', label: 'Average Value', isDefault: true },
  { value: 'sum', label: 'Total Sum' },
  { value: 'count', label: 'Total Count' },
  { value: 'unique_count', label: 'Unique Count' },
  { value: 'and', label: 'All True (AND)' },
  { value: 'or', label: 'Any True (OR)' },
  { value: 'first', label: 'First' },
  { value: 'last', label: 'Last' },
  { value: 'average_count', label: 'Average Count' }
]

const COLORING_OPTIONS = [
  { value: 'background', label: 'Background', isDefault: true },
  { value: 'font', label: 'Font' },
  { value: 'indicatorBar', label: 'Indicator Bar' },
  { value: '', label: 'None' }
]

const COLOR_TIERS_OPTIONS = [
  { value: 0, label: '0', isDefault: true },
  { value: 1, label: '1' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
]

const CARD_TYPE_OPTIONS = [
  { value: 'filledCard', label: 'Filled card', isDefault: true },
  { value: 'coloredText', label: 'Colored text', isDefault: false },
  { value: 'indicator', label: 'Indicator', isDefault: false }
]

const MAP_TYPE_OPTIONS = [
  { value: 'simple  ', label: 'Filled card', isDefault: true },
  { value: 'satellite', label: 'Satellite', isDefault: false }
]

const LABEL_DISPLAY_OPTIONS = [
  { value: 'value', label: 'Value', isDefault: true },
  { value: 'percent', label: 'Percent', isDefault: false },
]

const VALIDATION_HANDLERS = {
  required: (value) => value !== null && value !== undefined && !(value === '' || isEmpty(value)),
  isNumber: (value) => !isNaN(value),
  maxLength: (value, maxLength) => {
    if (typeof value !== 'string' && !Array.isArray(value)) {
      return true
    }
    return value.length <= maxLength
  },
}

export const calcGridChartHeight = (h) => {
  const gridRowHeight = 45
  const gridPadding = 85
  return (h * gridRowHeight) - gridPadding
}

export const calcChartContainerHeight = (height, hasXAxisTitle) => {
  const titleOffset = hasXAxisTitle ? 20 : 0
  return height - titleOffset
}

export const validateField = (field) => {
  const { validation } = field
  if (isEmpty(validation)) return true

  const valueFieldKeys = ['value', 'selectedOption', 'selectedOptions']
  const valueKey = valueFieldKeys.find(key => key in field) || null
  if (!valueKey) return false

  const value = field[valueKey]
  return Object.keys(validation).every(ruleKey => {
    if (ruleKey === 'required') {
      return VALIDATION_HANDLERS.required(value)
    }
    if (ruleKey === 'isNumber') {
      return VALIDATION_HANDLERS.isNumber(value)
    }
    if (ruleKey === 'maxLength') {
      const ruleValue = validation[ruleKey]
      return VALIDATION_HANDLERS.maxLength(value, ruleValue)
    }
    return true
  })


}

export const getDefaultOption = (options) => {
  const defaultOption = options.find(option => option.isDefault)
  if (defaultOption) return defaultOption
}

export const getChartTypeOption = (chartType) => {
  const chartTypeOption = CHART_TYPE_OPTIONS.find(option => option.value === chartType)
  if (chartTypeOption) return chartTypeOption
  return CHART_TYPE_OPTIONS.find(option => option.value === CHART_TYPE_LINE)
}

export const getMetricDataOptions = (metricData) => {
  if (metricData && !metricData.length) return []
  return metricData.map(data => ({
    label: data.tableName,
    options: data.metrics.map(metric => ({ label: metric.name, value: metric.name, table: data.tableName }))
  }))
}

export const getSelectedMetricData = () => { }

// FIELD TYPES
const TEXT_FIELD = 'text'
const MULI_SELECT_FIELD = 'multiSelect'
const SELECT_FIELD = 'select'
const TOGGLE_BUTTON_FIELD = 'toggleButton'
const COLLAPSIBLE_FIELD = 'collapsible'
const ITEM_CONFIG_FIELD = 'customConfig'
const FIELD_COMPONENTS_DICT = {}

export const CUSTOM_CONFIG_ITEM = {
  type: 'customConfig',
  id: '',
  label: '',
  placeholder: '',
  value: '',
  color: ''
}

const COMMON_FIELDS = {
  chartTitle: {
    id: 'title',
    type: 'text',
    label: 'Chart title',
    placeholder: 'Enter chart title',
    value: '',
  },
  chartType: {
    id: 'type',
    type: 'select',
    label: 'Chart type',
    selectedOption: { ...getDefaultOption(CHART_TYPE_OPTIONS) },
    placeholder: 'Select chart type',
    options: [...CHART_TYPE_OPTIONS],
    enableCustomConfigs: false,
    customConfigs: []
  },
  format: {
    id: 'format',
    type: 'select',
    label: 'Format',
    placeholder: 'Select format',
    selectedOption: { ...getDefaultOption(FORMAT_OPTIONS) },
    options: [...FORMAT_OPTIONS],
    enableCustomConfigs: false,
    customConfigs: []
  },
  decimal: {
    id: 'decimal',
    type: 'select',
    label: 'Decimals',
    placeholder: 'Select decimal',
    selectedOption: { ...getDefaultOption(DECIMAL_OPTIONS) },
    options: [...DECIMAL_OPTIONS],
    enableCustomConfigs: false,
    customConfigs: []
  },
  prefix: {
    id: 'prefix',
    type: 'text',
    label: 'Prefix',
    value: '',
    placeholder: ''
  },
  suffix: {
    id: 'suffix',
    type: 'text',
    label: 'Suffix',
    value: '',
    placeholder: ''
  },
  yAxisMin: {
    id: 'yAxisMin',
    type: 'text',
    label: 'Y-axis Min',
    placeholder: '0 (default)',
    value: '',
    validation: {
      isNumber: true
    }
  },
  yAxisMax: {
    id: 'yAxisMax',
    type: 'text',
    label: 'Y-axis Max',
    placeholder: 'Auto (default)',
    value: '',
    validation: {
      isNumber: true
    }
  },
  thresholdType: {
    id: 'thresholdType',
    type: 'select',
    label: 'Threshold type',
    placeholder: 'Select threshold type',
    selectedOption: { ...getDefaultOption(THRESHOLD_TYPE_OPTIONS) },
    options: [...THRESHOLD_TYPE_OPTIONS],
    enableCustomConfigs: false,
    customConfigs: []
  },
  devices: {
    id: 'devices',
    type: 'multiSelect',
    label: 'Devices',
    placeholder: 'Dashboard default',
    selectedOption: [],
    options: [],
    enableCustomConfigs: true,
    customConfigs: []
  },
  dateRange: {
    id: 'dateRange',
    type: 'select',
    label: 'Date range',
    placeholder: 'Dashboard default',
    selectedOption: {},
    options: [...DATE_RANGE_OPTIONS],
    enableCustomConfigs: false,
    customConfigs: []
  },
  chartInterval: {
    id: 'chartInterval',
    type: 'select',
    label: 'Chart interval',
    placeholder: 'Chart interval',
    selectedOption: { ...getDefaultOption(CHART_INTERVAL_OPTIONS) },
    options: [...CHART_INTERVAL_OPTIONS],
    enableCustomConfigs: false,
    customConfigs: []
  },
  intervalQuantity: {
    id: 'intervalQuantity',
    type: 'text',
    label: 'Interval Quantity',
    placeholder: '',
    value: '1'
  },
  dataPoint: {
    id: 'dataPoint',
    type: 'select',
    label: 'Data point',
    placeholder: 'Data point',
    selectedOption: { ...getDefaultOption(DATA_POINT_OPTIONS) },
    options: [...DATA_POINT_OPTIONS],
    enableCustomConfigs: false,
    customConfigs: []
  },
  timeFormat: {
    id: 'timeFormat',
    type: 'select',
    label: 'Time format',
    placeholder: 'Select time format',
    selectedOption: { ...getDefaultOption(DATE_FORMAT_OPTIONS) },
    options: [...DATE_FORMAT_OPTIONS],
    enableCustomConfigs: false,
    customConfigs: []
  },
  coloring: {
    id: 'coloring',
    type: 'select',
    label: 'Coloring',
    placeholder: 'Select coloring',
    selectedOption: { ...getDefaultOption(COLORING_OPTIONS) },
    options: [...COLORING_OPTIONS],
    enableCustomConfigs: false,
    customConfigs: []
  },
  colorTiers: {
    id: 'colorTiers',
    type: 'select',
    label: 'Color tiers',
    placeholder: 'Select color tiers',
    selectedOption: { ...getDefaultOption(COLOR_TIERS_OPTIONS) },
    options: [...COLOR_TIERS_OPTIONS],
    enableCustomConfigs: true,
    customConfigs: [],
  },
  groupBy: {
    id: 'groupBy',
    type: 'multiSelect',
    label: 'Group by',
    placeholder: '',
    selectedOption: [],
    options: [],
    enableCustomConfigs: false,
    customConfigs: []
  },
  legend: {
    id: 'legend',
    type: 'select',
    label: 'Legend position',
    placeholder: 'Select legend position',
    selectedOption: { ...getDefaultOption(LEGEND_OPTIONS) },
    options: [...LEGEND_OPTIONS],
    enableCustomConfigs: false,
    customConfigs: []
  },

  dataStreams: {
    id: 'dataStreams',
    type: 'dataStreams',
    value: 0,
    streams: []
  }
}

export const CARTESIAN_CHARTS_CONFIGURATION_V2 = {
  basicFields: [
    { ...COMMON_FIELDS.chartTitle },
    { ...COMMON_FIELDS.chartType },
    { ...COMMON_FIELDS.legend },
  ],
  dataStreamField: [
    { ...COMMON_FIELDS.dataStreams }
  ],
  dataFields: [
    {
      id: 'data',
      type: 'multiSelect',
      label: 'Select data',
      placeholder: 'Select data',
      selectedOption: [],
      options: [],
      enableCustomConfigs: true,
      customConfigs: []
    },
    {
      id: 'enableYAxisTitle',
      type: 'toggleButton',
      label: 'Enable Title',
      targetFieldIds: ['yAxisTitle'],
      value: false
    },
    {
      id: 'yAxisTitle',
      type: 'text',
      label: 'Y-axis title',
      placeholder: 'Title Name',
      value: ''
    },
    {
      id: 'chartLayout',
      type: 'select',
      label: 'Chart layout',
      placeholder: 'Select chart layout',
      selectedOption: { ...getDefaultOption(CHART_LAYOUT_OPTIONS) },
      options: [...CHART_LAYOUT_OPTIONS],
      enableCustomConfigs: false,
      customConfigs: []
    },
    { ...COMMON_FIELDS.format },
    { ...COMMON_FIELDS.decimal },
    { ...COMMON_FIELDS.prefix },
    { ...COMMON_FIELDS.suffix },
    { ...COMMON_FIELDS.yAxisMin },
    { ...COMMON_FIELDS.yAxisMax },
    {
      id: 'enableThreshold',
      type: 'toggleButton',
      label: 'Enable threshold',
      targetFieldIds: ['thresholdName', 'thresholdType'],
      value: false
    },
    {
      id: 'thresholdName',
      type: 'text',
      label: 'Threshold name',
      value: '',
    },
    {
      ...COMMON_FIELDS.thresholdType,
      enableCustomConfigs: true,
      customConfigs: [{
        ...CUSTOM_CONFIG_ITEM,
        id: 'thresholdConfig',
        label: 'Threshold',
        value: '80',
        color: '#2184f9'
      }]
    }
  ],
  xAxisFields: [
    {
      id: 'enableXAxisTitle',
      type: 'toggleButton',
      label: 'Enable title',
      targetFieldIds: ['xAxisTitle'],
      value: false,
    },
    {
      id: 'xAxisTitle',
      type: 'text',
      label: 'X-axis title',
      value: '',
      placeholder: 'Title Name'
    },
    { ...COMMON_FIELDS.timeFormat },
    {
      ...COMMON_FIELDS.groupBy,
      enableCustomConfigs: true,
    }
  ],
  scopeFields: [
    { ...COMMON_FIELDS.devices },
    { ...COMMON_FIELDS.dateRange },
    { ...COMMON_FIELDS.chartInterval },
    { ...COMMON_FIELDS.intervalQuantity },
    { ...COMMON_FIELDS.dataPoint }
  ]
}

export const TABLE_CHART_COLLAPSIBLE_DEFAULT_FIELDS = {
  metric: '',
  fields: [
    {
      id: 'title',
      type: 'text',
      label: 'Column title',
      placeholder: 'Title name',
      value: '',
    },
    { ...COMMON_FIELDS.decimal },
    { ...COMMON_FIELDS.prefix },
    { ...COMMON_FIELDS.suffix },
    { ...COMMON_FIELDS.coloring },
    { ...COMMON_FIELDS.thresholdType },
    { ...COMMON_FIELDS.colorTiers }
  ]
}

export const TABLE_CHARTS_CONFIGURATION_V2 = {
  basicFields: [
    { ...COMMON_FIELDS.chartTitle },
    {
      ...COMMON_FIELDS.chartType,
      selectedOption: { ...getChartTypeOption(CHART_TYPE_TABLE) }
    }
  ],
  dataStreamField: [
    { ...COMMON_FIELDS.dataStreams }
  ],
  dataFields: [
    {
      id: 'data',
      type: 'multiSelect',
      label: 'Select data',
      placeholder: 'Select data',
      selectedOption: [],
      options: [],
      enableCustomConfigs: false,
      customConfigs: []
    },
    {
      id: 'dataCallapsibleConfigs',
      type: 'collapsible',
      dataConfigs: [],
      defaultConfig: {
        metric: '',
        fields: [
          {
            id: 'title',
            type: 'text',
            label: 'Column title',
            placeholder: 'Title name',
            value: '',
          },
          { ...COMMON_FIELDS.decimal },
          { ...COMMON_FIELDS.prefix },
          { ...COMMON_FIELDS.suffix },
          { ...COMMON_FIELDS.coloring },
          {
            ...COMMON_FIELDS.thresholdType,
            selectedOption: { ...getDefaultOption(THRESHOLD_TYPE_LABEL_OPTIONS) },
            options: [...THRESHOLD_TYPE_LABEL_OPTIONS],
            persistOptions: true
          },
          { ...COMMON_FIELDS.colorTiers }
        ]
      }
    }
  ],
  scopeFields: [
    { ...COMMON_FIELDS.devices },
    { ...COMMON_FIELDS.dateRange },
    {
      id: 'columnMetricData',
      type: 'select',
      label: 'Column data',
      placeholder: 'Set data point',
      targetFieldIds: ['dataPoint'],
      selectedOption: { ...getDefaultOption(COLUMN_METRIC_DATA_OPTIONS) },
      options: [...COLUMN_METRIC_DATA_OPTIONS],
      enableCustomConfigs: true,
      customConfigs: []
    },
    { ...COMMON_FIELDS.chartInterval },
    { ...COMMON_FIELDS.intervalQuantity },
    {
      ...COMMON_FIELDS.timeFormat,
      id: 'intervalFormat',
      label: 'Interval format',
      placeholder: 'Select interval format',
    },
    {
      id: 'intervalTitle',
      type: 'text',
      label: 'Interval title',
      placeholder: 'Display text',
      value: '',
    }
  ]
}

export const CARD_CHARTS_CONFIGURATION = {
  basicFields: [
    { ...COMMON_FIELDS.chartTitle },
    {
      ...COMMON_FIELDS.chartType,
      selectedOption: { ...getChartTypeOption(CHART_TYPE_CARD) }
    }
  ],
  dataStreamField: [
    { ...COMMON_FIELDS.dataStreams }
  ],
  dataFields: [
    {
      id: 'data',
      type: 'multiSelect',
      label: 'Select data',
      placeholder: 'Select data',
      selectedOption: [],
      options: [],
      enableCustomConfigs: true,
      customConfigs: []
    },
    {
      id: 'cardType',
      type: 'select',
      label: 'Card type',
      placeholder: '',
      selectedOption: { ...getDefaultOption(CARD_TYPE_OPTIONS) },
      options: [...CARD_TYPE_OPTIONS],
      enableCustomConfigs: false,
      customConfigs: []
    },
    { ...COMMON_FIELDS.format },
    { ...COMMON_FIELDS.decimal },
    { ...COMMON_FIELDS.prefix },
    { ...COMMON_FIELDS.suffix },
    {
      ...COMMON_FIELDS.thresholdType,
      selectedOption: { ...getDefaultOption(THRESHOLD_TYPE_LABEL_OPTIONS) },
      options: [...THRESHOLD_TYPE_LABEL_OPTIONS],
      persistOptions: true
    },
    { ...COMMON_FIELDS.colorTiers }
  ],
  scopeFields: [
    { ...COMMON_FIELDS.devices },
    { ...COMMON_FIELDS.dateRange },
    { ...COMMON_FIELDS.dataPoint }
  ]
}

export const DOUGHNUT_CHARTS_CONFIGURATION = {
  basicFields: [
    { ...COMMON_FIELDS.chartTitle },
    {
      ...COMMON_FIELDS.chartType,
      selectedOption: { ...getChartTypeOption(CHART_TYPE_DOUGHNUT) }
    },
    { ...COMMON_FIELDS.legend },
  ],
  dataStreamField: [
    { ...COMMON_FIELDS.dataStreams }
  ],
  dataFields: [
    {
      id: 'data',
      type: 'multiSelect',
      label: 'Select data',
      placeholder: 'Select data',
      selectedOption: [],
      options: [],
      enableCustomConfigs: true,
      customConfigs: []
    },
    {
      id: 'enableDataTitle',
      type: 'toggleButton',
      label: 'Enable Title',
      targetFieldIds: ['dataTitle'],
      value: false
    },
    {
      id: 'dataTitle',
      type: 'text',
      label: 'Data title',
      placeholder: 'Title Name',
      value: ''
    },
    { ...COMMON_FIELDS.format },
    { ...COMMON_FIELDS.decimal },
    { ...COMMON_FIELDS.prefix },
    { ...COMMON_FIELDS.suffix },
    { ...COMMON_FIELDS.groupBy }
    // {
    //   id: 'enableThreshold',
    //   type: 'toggleButton',
    //   label: 'Enable thresholds',
    //   targetFieldIds: ['thresholdType', 'colorTiers'],
    //   value: false
    // },
    // {...COMMON_FIELDS.thresholdType},
    // {...COMMON_FIELDS.colorTiers}
  ],
  scopeFields: [
    { ...COMMON_FIELDS.devices },
    { ...COMMON_FIELDS.dateRange },
    { ...COMMON_FIELDS.dataPoint }
  ]
}

export const GAUGE_CHARTS_CONFIGURATION = {
  basicFields: [
    { ...COMMON_FIELDS.chartTitle },
    {
      ...COMMON_FIELDS.chartType,
      selectedOption: { ...getChartTypeOption(CHART_TYPE_GAUGE) }
    },
    { ...COMMON_FIELDS.legend },
  ],
  dataStreamField: [
    { ...COMMON_FIELDS.dataStreams }
  ],
  dataFields: [
    {
      id: 'data',
      type: 'multiSelect',
      label: 'Select data',
      placeholder: 'Select data',
      selectedOption: [],
      options: [],
      enableCustomConfigs: true,
      customConfigs: []
    },
    {
      id: 'enableDataTitle',
      type: 'toggleButton',
      label: 'Enable Title',
      targetFieldIds: ['dataTitle'],
      value: false
    },
    {
      id: 'dataTitle',
      type: 'text',
      label: 'Data title',
      placeholder: 'Title Name',
      value: ''
    },
    { ...COMMON_FIELDS.format },
    { ...COMMON_FIELDS.decimal },
    { ...COMMON_FIELDS.prefix },
    { ...COMMON_FIELDS.suffix },
    {
      id: 'enableThreshold',
      type: 'toggleButton',
      label: 'Enable thresholds',
      targetFieldIds: ['thresholdType', 'colorTiers'],
      value: false
    },
    { ...COMMON_FIELDS.thresholdType },
    { ...COMMON_FIELDS.colorTiers }
  ],
  scopeFields: [
    { ...COMMON_FIELDS.devices },
    { ...COMMON_FIELDS.dateRange },
    { ...COMMON_FIELDS.dataPoint }
  ]
}

export const PIE_CHARTS_CONFIGURATION = {
  basicFields: [
    { ...COMMON_FIELDS.chartTitle },
    {
      ...COMMON_FIELDS.chartType,
      selectedOption: { ...getChartTypeOption(CHART_TYPE_PIE) }
    },
    { ...COMMON_FIELDS.legend },
  ],
  dataStreamField: [
    { ...COMMON_FIELDS.dataStreams }
  ],
  dataFields: [
    {
      id: 'data',
      type: 'multiSelect',
      label: 'Select data',
      placeholder: 'Select data',
      selectedOption: [],
      options: [],
      enableCustomConfigs: true,
      customConfigs: []
    },
    {
      id: 'enableDataTitle',
      type: 'toggleButton',
      label: 'Enable Title',
      targetFieldIds: ['dataTitle'],
      value: false
    },
    {
      id: 'dataTitle',
      type: 'text',
      label: 'Data title',
      placeholder: 'Title Name',
      value: ''
    },
    { ...COMMON_FIELDS.format },
    { ...COMMON_FIELDS.decimal },
    { ...COMMON_FIELDS.prefix },
    { ...COMMON_FIELDS.suffix },
    {
      id: 'enableLabels',
      type: 'toggleButton',
      label: 'Always show labels',
      targetFieldIds: [],
      value: false
    },
    {
      id: 'labelDisplay',
      type: 'select',
      label: 'Display',
      selectedOption: { ...getDefaultOption(LABEL_DISPLAY_OPTIONS) },
      placeholder: '',
      options: [...LABEL_DISPLAY_OPTIONS],
      enableCustomConfigs: false,
      customConfigs: []
    },
    { ...COMMON_FIELDS.groupBy }
  ],
  scopeFields: [
    { ...COMMON_FIELDS.devices },
    { ...COMMON_FIELDS.dateRange },
    { ...COMMON_FIELDS.dataPoint }
  ]
}

export const HEATMAP_CHARTS_CONFIGURATION = {
  basicFields: [
    { ...COMMON_FIELDS.chartTitle },
    {
      ...COMMON_FIELDS.chartType,
      selectedOption: { ...getChartTypeOption(CHART_TYPE_HEATMAP) }
    },
    { ...COMMON_FIELDS.legend },
  ],
  dataStreamField: [
    { ...COMMON_FIELDS.dataStreams }
  ],
  dataFields: [
    {
      id: 'data',
      type: 'multiSelect',
      label: 'Select data',
      placeholder: 'Select data',
      selectedOption: [],
      options: [],
      enableCustomConfigs: true,
      customConfigs: []
    },
    {
      id: 'enableDataTitle',
      type: 'toggleButton',
      label: 'Enable Title',
      targetFieldIds: ['dataTitle'],
      value: false
    },
    {
      id: 'dataTitle',
      type: 'text',
      label: 'Data title',
      placeholder: 'Title Name',
      value: ''
    },
    { ...COMMON_FIELDS.format },
    { ...COMMON_FIELDS.decimal },
    { ...COMMON_FIELDS.prefix },
    { ...COMMON_FIELDS.suffix },
    {
      id: 'enableThreshold',
      type: 'toggleButton',
      label: 'Enable thresholds',
      targetFieldIds: ['thresholdType', 'colorTiers'],
      value: false
    },
    { ...COMMON_FIELDS.thresholdType },
    { ...COMMON_FIELDS.colorTiers }
  ],
  scopeFields: [
    { ...COMMON_FIELDS.devices },
    { ...COMMON_FIELDS.dateRange },
    { ...COMMON_FIELDS.dataPoint }
  ]
}

export const MAP_CHARTS_CONFIGURATION = {
  basicFields: [
    { ...COMMON_FIELDS.chartTitle },
    {
      ...COMMON_FIELDS.chartType,
      selectedOption: { ...getChartTypeOption(CHART_TYPE_MAP) }
    },
  ],
  dataStreamField: [
    { ...COMMON_FIELDS.dataStreams }
  ],
  dataFields: [
    {
      id: 'data',
      type: 'multiSelect',
      label: 'Select data',
      placeholder: 'Select data',
      selectedOption: [],
      options: [],
      enableCustomConfigs: true,
      customConfigs: []
    },
    {
      id: 'mapType',
      type: 'select',
      label: 'Map type',
      placeholder: '',
      selectedOption: { ...getDefaultOption(MAP_TYPE_OPTIONS) },
      options: [...MAP_TYPE_OPTIONS],
      enableCustomConfigs: false,
      customConfigs: []
    },
    { ...COMMON_FIELDS.format },
    { ...COMMON_FIELDS.decimal },
    { ...COMMON_FIELDS.prefix },
    { ...COMMON_FIELDS.suffix },
    {
      ...COMMON_FIELDS.thresholdType,
      selectedOption: { ...getDefaultOption(THRESHOLD_TYPE_LABEL_OPTIONS) },
      options: [...THRESHOLD_TYPE_LABEL_OPTIONS],
      persistOptions: true
    },
    { ...COMMON_FIELDS.colorTiers }
  ],
  scopeFields: [
    { ...COMMON_FIELDS.devices },
    { ...COMMON_FIELDS.dateRange },
    { ...COMMON_FIELDS.dataPoint }
  ]
}